const clauseData = [
  /* LISTING CLAUSES */
  {
    type: "clause",
    category: [`forsale`],
    isCommon: "yes",
    title: "List of Services to be Provided to the Seller",
    notes: `As mentioned, Schedule A is a required part of every Agreement and 
    must outline the services you will provide to the client. It should be 
    treated as a living document, evolving as you expand your list of services.  
    <br/><br/>
    See below for a sample "starter list" that you can build upon. (May require 
    further editing to fit your needs.)`,
    text: `The Designated Representative(s) will: <br/>
Advise you on market conditions<br/>
Keep you up to date with respect to changing market conditions<br/>
Advise you concerning the best strategy to attract Buyers and achieve the best price for your home<br/>
Market or advertise your home, on MLS and various other internet formats<br/>
Arrange photographs for your property<br/>
Provide recommendations and referrals to other professionals, as required<br/>
Arrange showings for prospective Buyers<br/>
Review offers<br/>
Advise you on how to handle offers, multiple offers, and competing offers<br/>
Advise you on various other aspects of the transaction<br/>
Negotiate with Buyers/agents to achieve the best results, price, and terms, for you<br/>
Assist you with the successful closing of the transaction.`,
  },
  {
    type: "clause",
    category: [`forlease`],
    isCommon: "yes",
    title: "List of Services to be Provided to the Landlord",
    notes: `As mentioned, Schedule A is a required part of every Agreement and 
    must outline the services you will provide to the client. It should be 
    treated as a living document, evolving as you expand your list of services.  
    <br/><br/>
    See below for a sample "starter list" that you can build upon. (May require 
    further editing to fit your needs.)`,
    text: `The Designated Representative(s) will: <br/>
Advise you on market conditions<br/>
Keep you up to date with respect to changing market conditions<br/>
Advise you concerning the best strategy to attract Tenants and achieve the best price for your rental<br/>
Market or advertise your rental, on MLS and various other internet formats<br/>
Arrange photographs for your property<br/>
Provide recommendations and referrals to other professionals, as required<br/>
Arrange showings for prospective Tenants<br/>
Review offers<br/>
Advise you on how to handle offers, multiple offers, and competing offers<br/>
Advise you on various other aspects of the transaction<br/>
Negotiate with Tenants/agents to achieve the best results, price, and terms, for you<br/>
Assist you with the successful closing of the transaction.`,
  },
  {
    type: "clause",
    category: [`forsale`],
    isCommon: "yes",
    title: "Permission for other eXp Agents to Hold Open Houses",
    notes: `This clause can be used when the Seller agrees to allow other eXp agents 
    to host Open Houses during the listing term, at an agreed upon time. The Sellers 
    consent is required if an eXp agent not named in the agreement is to host an Open 
    House.`,
    text: `The Sellers hereby authorize the Designated Agents to arrange for other eXp Realty licensees to host open houses and the Sellers acknowledge and accept that the host licensee WILL NOT be a designated agent of the Sellers. <br/><br/>
    
    The "host licensee" has no confidential information about the Seller or the property and the listing Designated Agent does not intend the "host licensee" to be the designated agent of the Seller.
    `,
  },
  {
    type: "clause",
    category: [`forsale`],
    isCommon: "yes",
    title: "Seller Indemnifies eXp Realty from Claims",
    notes: `The purpose of this clause is to protect the real estate agent and eXp 
    Realty from any financial or legal responsibility for damages, theft, or other 
    incidents that may occur to the Sellers property while it is listed for sale.`,
    text: `The Sellers agree to indemnify, the designated real estate agent (REALTOR®), and the real estate company (Broker), eXp Realty or any one of them, from any and all liability, claims, actions, suits, demands, costs or expenses of every kind arising from the subject property’s theft, burglary, vandalism and or any damages, caused whether by natural phenomenon or caused by known or unknown factor while the property is listed and marketed by the real estate agent and real estate company. The Seller must and agrees to have sufficient home insurance policy and security in place for such incidents.`,
  },
  {
    type: "clause",
    category: [`forlease`],
    isCommon: "yes",
    title: "Landlord Indemnifies eXp Realty from Claims",
    notes: `The purpose of this clause is to protect the real estate agent and eXp 
    Realty from any financial or legal responsibility for damages, theft, or other 
    incidents that may occur to the Landlord's property while it is listed for lease.`,
    text: `The Landlord agrees to indemnify, the designated real estate agent (REALTOR®), and the real estate company (Broker), eXp Realty or any one of them, from any and all liability, claims, actions, suits, demands, costs or expenses of every kind arising from the subject property’s theft, burglary, vandalism and or any damages, caused whether by natural phenomenon or caused by known or unknown factor while the property is listed and marketed by the real estate agent and real estate company. The Landlord must and agrees to have sufficient home insurance policy and security in place for such incidents.`,
  },
  {
    type: "clause",
    category: [`forsale`],
    isCommon: "yes",
    title: "Permission for Professional Marketing Company to Enter Property",
    notes: `This clause allows the Seller to give formal permission for the 
    Designated Agent to let a marketing company enter the property without the agent 
    being present. The purpose is to enable professionals to take photos, make floor 
    plans, and carry out other marketing activities needed to promote and sell the 
    property efficiently.`,
    text: `The Seller hereby acknowledges and authorizes the Designated Agent to permit access to the Property by a professional marketing company, without the presence of the Designated Agent, for the purpose of conducting photography, creating floor plans, and performing any other marketing activities deemed necessary for the promotion and sale of the Property.`,
  },
  /* CONDITIONS/SUBJECTS LIST*/
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Financing Approval`,
    notes: `This clause protects the Buyer by making the purchase conditional on securing 
    satisfactory financing by a set date. It also allows access for an appraisal 
    required by lenders and clarifies that the condition benefits only the Buyer, 
    giving them the option to withdraw if financing isn't obtained.<br/>`,
    text: `Subject to the Buyer(s) obtaining satisfactory financing on or before _____________. Seller(s) will allow access to the property for the purpose of property appraisal on reasonable notice. This condition is for the sole benefit of the Buyer.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Inspection of Property`,
    notes: `This clause protects the Buyer by allowing them to inspect the property at 
    their own expense and withdraw if they're not satisfied with the results by a set 
    date. It also requires the Seller to provide reasonable access for inspections and 
    confirms that the condition benefits only the Buyer.<br/>`,
    text: `Subject to the Buyer obtaining, at the Buyer's expense, an inspection report and the Buyer being satisfied, on or before _____________, with the results of the inspection report. The Seller, on reasonable notice, will allow access to the Property for the purpose of the inspection(s). This condition is for the sole benefit of the Buyer.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Title Review`,
    notes: `This clause protects the Buyer by giving them time to review and approve the 
    property's title, including any encumbrances or legal notations, before finalizing 
    the purchase. It ensures the Buyer can back out if they're not satisfied and confirms 
    that only approved items will remain on title at completion, with the condition 
    benefiting solely the Buyer.<br/>`,
    text: `Subject to the Buyer being satisfied, on or before _____________, with the title, encumbrances and legal notations affecting or benefitting the Property. If approved, such statement will be incorporated into and form part of this contract. On the Completion Date, in addition to the encumbrances set out in section 9 of the Contract, title to the Property—excluding financial charges—will remain subject to the encumbrances and legal notations shown on the title search, which will be incorporated into and forms part of this Contract. This condition is for the sole benefit of the Buyer.`,
  },
  {
    type: "clause",
    category: [`condo`],
    isCommon: "yes",
    title: `Property Disclosure Statement`,
    notes: `This clause allows the Buyer to review and approve the strata Property 
    Disclosure Statement before committing to the purchase. It protects the Buyer by 
    ensuring they can withdraw if the disclosure reveals issues—like bylaws, repairs, 
    or levies—that could negatively affect the property's use or value.<br/>`,
    text: `Subject to the Buyer obtaining and approving, on or before _____________, a Property Disclosure Statement - Strata Title Properties, with respect to information that reasonably may adversely affect the use or value of the strata lot, including any bylaw, item of repair or maintenance, special levy, judgment or other liability, whether actual or potential. This condition is for the sole benefit of the Buyer. If approved, such statement will be incorporated into and form part of this contract.`,
  },
  {
    type: "clause",
    category: [`residential`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Property Disclosure Statement`,
    notes: `This clause gives the Buyer time to review and approve the Property 
    Disclosure Statement before finalizing the purchase. It protects the Buyer by 
    allowing them to withdraw if the statement reveals concerns and ensures that, once 
    accepted, the disclosure becomes part of the contract.<br/>`,
    text: `Subject to the Buyer obtaining and being satisfied, on or before _____________, with a Property Disclosure Statement with respect to the Property.

 This condition is for the sole benefit of the Buyer.

 If this condition is satisfied or waived, the Property Disclosure Statement will be incorporated into and form part of this Contract.
`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Insurance (Fire/Property)`,
    notes: `This clause protects the Buyer by making the purchase conditional on securing 
    satisfactory property and liability insurance by a set date. It ensures the Buyer 
    can withdraw if they're unable to obtain acceptable insurance coverage.<br/>`,
    text: `Subject to the Buyer obtaining approval, on or before _____________, from a licensed insurer for property (including fire) and liability insurance for the Property on terms and at rates satisfactory to the Buyer. This condition is for the sole benefit of the Buyer.`,
  },
  {
    type: "clause",
    category: [`condo`],
    isCommon: "yes",
    title: `Strata Documents Review`,
    notes: `This clause protects the Buyer by giving them time to review and approve 
    important strata documents—such as bylaws, budgets, meeting minutes, insurance 
    details, and engineering or legal reports—before finalizing the purchase. It ensures 
    the Buyer can withdraw if the documents reveal issues that may affect the property's 
    value or use, and it specifies that the Seller must provide these materials.<br/>`,
    text: `Subject to the Buyer(s), receiving and approving, on or before _____________, the following documents with respect to information that reasonably may adversely affect the use or value of the lot, including any bylaw, item of repair or maintenance, special levy, judgment or other liability, whether actual or potential.<br/>
* A Form "B" from the strata, the corporation's rules, current budget, the developer's Rental Disclosure Statement (if any), and the most recent depreciation report obtained by the strata corporation (if any);<br/>
* If relevant, a Form "B" Information Certificate from the section, attaching the section's rules, current budget, the developer's Rental Disclosure Statement (if any), and the most recent depreciation report obtained by the strata corporation (if any);<br/>
* A copy of the registered strata plan, any amendments to the strata plan, and any resolutions dealing with changes to common property.<br/>
* The current bylaws and financial statements of the strata corporation, and any section to which the strata corporation lot belongs;<br/>
* The minutes of any meeting held between the period from _______ to current date by the strata council, and by the members in annual, extraordinary or special general meetings (AGM to include President's Report or Annual Summary), and by the members or the executive of any section to which the strata lot belongs.<br/>
* The current insurance cover note explaining the strata corporation's insurance coverage and deductibles.<br/>
* A building envelope study report; and a copy of any engineers "or other consultants" report concerning this strata corporation, (if any);<br/>
* Documentations concerning any lawsuits, legal opinions and warranties for this strata corporation (if any);<br/>
* Any warranty documentations concerning a building envelope including a roof as defined in the Building Envelope Renovation Regulation (B.C. Regulation 240/2000), (if any). This condition is for the sole benefit of the Buyer.<br/>
* The Seller or Seller's agent will make available to the Buyer any minutes of Strata Council meetings which are subsequently produced (to those above) prior to completion date.<br/>
These conditions are for the sole benefit of the Buyer.<br/>
Immediately upon acceptance of this offer, the Seller(s) will authorize the Seller's agent, to request, at the Seller's expense, complete copies of the documents listed above from the strata corporation or other source and to immediately, upon receipt, deliver the documents to the Buyer (or the Buyer's agent).`,
  },
  {
    type: "clause",
    category: [`condo`],
    isCommon: "yes",
    title: `Strata Insurance`,
    notes: `This clause protects the Buyer by allowing them to review and approve the 
    strata corporation's insurance terms and confirm they can obtain their own suitable 
    strata owner insurance. It ensures the Buyer can withdraw if coverage, premiums, or 
    deductibles are unsatisfactory, and requires the Seller to promptly provide the 
    relevant insurance documents.<br/>`,
    text: `Subject to: (A) the Buyer reviewing and approving, on or before _____________, the terms and rates of the strata corporation’s insurance, including the premium amounts, deductible amounts, and coverage limits thereunder and the date of expiration of such policy or policies; and (B) the Buyer confirming the Buyer’s ability to obtain personal strata owner insurance on terms satisfactory to the Buyer, including coverage for any owner’s portions of deductibles payable under the strata corporation’s insurance, in each case. These conditions are for the sole benefit of the Buyer.<br/><br/>
    Immediately upon execution and delivery of this Contract of Purchase and Sale by all parties, the Seller or the Seller’s agent, will obtain copies of the strata corporation insurance policy or policies, or a summary of coverage, a cover note or a binder in respect of same, and will immediately, upon receipt, deliver such document(s) or cause such document(s) to be delivered to the Buyer or the Buyer’s agent.
    `,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Approval by Buyer's Professional Advisors`,
    notes: `This clause allows the Buyers legal, accounting, or other advisors to review 
    and approve the contract before the purchase is finalized. It protects the Buyer by 
    giving them the option to withdraw if their advisors find any issues.<br/>`,
    text: `Subject to the Buyer receiving, on or before _____________, approval by the Buyer’s legal, accounting and other professional advisors of the terms and conditions of this Contract. This condition is for the sole benefit of the Buyer.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Sale of Buyer's Property w/ Seller Invoking Time Clause`,
    notes: `This clause protects the Buyer by making their purchase conditional on 
    selling their own property first. It also allows the Seller to accept another offer 
    by giving the Buyer a set time to remove their conditions; if the Buyer can't do so, 
    the contract ends and their deposit is returned.<br/>`,
    text: `Subject to the Buyer entering into a contract to sell the Buyer's property at (INSERT ADDRESS) and that contract becoming unconditional on or before _____________. This condition is for the sole benefit of the Buyer. <br/><br/>
    
    The Seller may upon receipt of another acceptable offer for the Property deliver written notice to the Buyer or to (name of Buyer’s agent and brokerage) requiring the Buyer to waive or satisfy all conditions in this Contract within ___ hours of the delivery of the written notice, not to include Sundays and statutory holidays. If the Buyer fails to waive or satisfy all of the conditions before expiry of the notice period this Contract will terminate and the Deposit will be returnable in accordance with the Real Estate Services Act.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Backup Offer`,
    notes: `This clause protects the Seller by ensuring they are fully released from any 
    prior sale contract for the property before completing the new sale. It prevents 
    the Seller from being bound by multiple agreements.<br/>`,
    text: `Subject to the Seller ceasing to be obligated in any way under the Contract of Purchase and Sale dated ________ (the “Sale Contract”) respecting the Property, including the Seller obtaining a full release from the Buyer, on or before ___________. This condition is for the sole benefit of the Seller. <br/>
    ***(Optional - The Seller agrees not to amend the Sale Contract.)`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Approval of Tenancy Agreement`,
    notes: `Tenancy agreements contain Tenant's personal information, as defined in 
    the Personal Information Protection Act.Before providing the tenancy agreement 
    to the Buyer, the Seller or the Seller's licensee should obtain the Tenant's 
    consent to that disclosure. If consent cannot be obtained, the Seller and/or the 
    Seller's licensee should obtain legal advice relating to their obligations under 
    privacy law.
    `,
    text: `Subject to the Buyer receiving and being satisfied with, on or before ___________, the tenancy agreement for the Property. This condition is for the sole benefit of the Buyer.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Estate Condition for benefit of Buyer and Seller`,
    notes: `This clause ensures that the legal requirements for selling an estate 
    property are completed before the sale proceeds. It protects both parties by 
    confirming the Seller has authority to sell, the title transfer is properly 
    registered, and any potential estate claims are resolved; neither the Buyer nor the 
    Seller can waive this condition alone.<br/>`,
    text: `Subject to the Seller obtaining and providing the following to the Buyer by ______________:
1. a copy of a grant of probate or letters of administration allowing the Property to be sold (the “Estate Documents”);
2. confirmation that a transmission of the title to the Property to the administrator or executor appointed in the Estate Documents (the “Transmission”) has reached final registration in the Land Title Office; and
3. assurance of the Seller, satisfactory to the Buyer, that everyone entitled to claim under the Wills, Estates and Succession Act has waived or released their claims in relation to the Property.
This condition (the “Estate Condition”) is for the benefit of the Seller and the Buyer and cannot be unilaterally waived by either of them.
`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "yes",
    title: `Seller Conditional Purchase`,
    notes: `This clause protects the Seller by making the sale conditional on them 
    securing and finalizing the purchase of another home. It ensures the Seller isn't 
    left without a place to move into.<br/>`,
    text: `Subject to the Seller entering into a contract to purchase another residence and that contract becoming unconditional on or before ___________. This condition is for the sole benefit of the Seller.`,
  },
  /* TERMS LIST */
  {
    type: "clause",
    category: [`assignPurchase`],
    isCommon: "no",
    title: `Protect Assignee Clause from Assignor Taxes`,
    notes: `The Assignee could be held responsible to paying the assignors taxes 
    if funds were released to an Assignor and the Assignor is not deemed a resident 
    for income tax purposes. To protect your client from potentially paying a HUGE 
    amount of tax that was owed by the assignor, add the following term to the 
    contract.<br/>
    ***ERASE TEXT WITHIN BRACKETS from the Clause as they are there for explanation***`,
    text: `If the Assignor claims to be a resident of Canada as described in the residency provisions of the Income Tax Act, the assignor will supply the assignee with a copy of the statutory declaration of residency on or before _____________(This date should be before when money is to be released to assignor ie, before SR or before completion). If the declaration is not provided by _____________(day of money release), the stakeholders of the deposits for the assignee will hold back 50% of all money payable. If at a later date the assignor is able to provide the declaration prior to completion, the withheld amount will then be release to the assignor.`,
  },
  {
    type: "clause",
    category: [`assignPurchase`],
    isCommon: "no",
    title: `Option D Clause - When total deposit does not equal assignment amount`,
    notes: `This clause is to be used when the deposit does not equal the 
    assignment amount. This addresses the deposit to be released at subject removal 
    and the Commission and Lift at completion.
    `,
    text: `Upon satisfaction or removal of all of the subject conditions,  $______________ ,being a sum equal to the deposits paid to date by the assignor, is due and payable directly to the assignor. If such sum is not received within ________ of subject removal this Assignment Agreement is null and Void _______ days before the scheduled completion date, $__________ (the balance of the Assignment Amount) will be payable to _____(insert brokerage or assignee lawyer)_________________ (the stakeholder) and is to be released to the assignor (and any real estate commission is then payable) upon the transfer of the property being submitted for registration in the appropriate Land Title and Survey Authority office.`,
  },
  {
    type: "clause",
    category: [`assignPurchase`],
    isCommon: "no",
    title: `Option D Clause - When total deposit is larger than the original deposit but less than the assignment amount.`,
    notes: `Use this clause to reimburse the Assignor's original deposit after 
    condition removal while holding the balance in trust until registration, with 
    a fail-safe if registration doesn't occur.
    `,
    text: `When all conditions, if any, are waived or satisfied, the portion of the assignment amount equal to the deposits paid by the Assignor in amount of $___(A =original deposit amount)_________is to be released to the Assignor. The balance $____(B =total deposit before completion paid minus original deposit)____________is to be held in trust by the stakeholder and is to be released to the Assignor (and any real estate commission with respect to this Assignment Agreement is then payable) along with the balance of the assignment in amount of $____(C=total assignment amount minus A and B)__________upon the transfer of the Property being submitted for registration in the appropriate Land Title Office and if that does not happen by the latest date specified in the Contract, at the option of the Assignee, the Assignment Amount is to be released to the Assignee and this Assignment Agreement shall be terminated.`,
  },
  {
    type: "clause",
    category: [`assignPurchase`],
    isCommon: "no",
    title: `Option D Clause - When there are multiple deposits and release dates.`,
    notes: `Use this when you need a firm payment date and a clear release trigger 
    (e.g., subject removal, developer consent, or completion) for the Assignor's 
    funds.<br/>
    ***Repeat this clause until it adds up to the full assignment amount***<br/>
    ***To address commission add “and any real estate commission with respect to this Assignment Agreement is then payable” to the clause.***
    `,
    text: `Assignor and Assignee agree that $___________ will be paid on ______(date)____and released to the assignor _____(pick one: on ___date___, at subject removal, after developer consent, at completion)______.`,
  },
  {
    type: "clause",
    category: [`20A`],
    isCommon: "no",
    title: `Additional Named Buyer - 20A`,
    notes: `This clause allows the Buyer to add another person to the purchase agreement 
    before completion without needing the Seller's further consent. It ensures 
    flexibility for the Buyer while confirming that the original Buyer remains fully 
    responsible under the contract.<br/>
    ***For transparency purposes, it is highly recommended to also cross off 20A on the 
    contract and have all parties initial.
    `,
    text: `Notwithstanding section 20A of this Contract, the Buyer may, without the further consent of the Seller, add (insert name(s) of specific person(s)) as an additional Buyer prior to completion and the Seller agrees to sign completion documents as are necessary to reflect that addition. The Seller’s consent does not release the Buyer from liability under this Contract.`,
  },
  {
    type: "clause",
    category: [`20A`],
    isCommon: "no",
    title: `Assignment - 20A`,
    notes: `This clause allows the Buyer to assign their rights in the contract to 
    another person without needing the Seller's further consent. It ensures flexibility 
    for the Buyer while confirming that the original Buyer remains fully responsible 
    under the contract.<br/>`,
    text: `The Buyer may assign the Buyer's rights in this Contract, in whole or in part, to any person without the consent of the Seller. The assignment by the Buyer will not relieve the Buyer from the Buyer’s obligations under this Contract.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`, `assign`, `assignmere`],
    isCommon: "no",
    title: `Force Majeure Wildfire/Flooding`,
    notes: `This clause protects the Buyer if a wildfire or flood makes it temporarily 
    impossible to get fire insurance, allowing them to extend key dates without 
    penalty. It also keeps the deal fair by letting the Seller accelerate closing 
    once insurance becomes available, while ensuring all deadlines remain binding. You 
    should recommend that your client obtain legal advice regarding how triggering 
    this clause may affect any related transactions that are closing on your client's 
    original completion dates.
`,
    text: `If, as a result of a wildfire/flooding and despite the Buyer's best efforts, the Buyer is unable to obtain fire insurance on the Property that is binding and effective as of the original Completion Date, on terms and at rates that are commercially reasonable, then the Buyer may, at their sole discretion, extend each of the Completion Date, the Adjustment Date and the Possession Date to a date that is the first day, other than a Saturday, Sunday or statutory holiday in British Columbia (“Business Day”) that is [30] calendar days after the original respective dates by providing written notice (the “Extension Notice”) to the Seller or the Seller’s agent at least [5] Business Days before the original Completion Date.<br/><br/>
    
     If during the period between the delivery of the Extension Notice and [5] Business Days before the extended Completion Date the Buyer obtains fire insurance on the Property that would allow the Buyer to complete the purchase and sale of the Property before the extended Completion Date, the Buyer will immediately provide written notice of same to the Seller or the Seller’s agent (the “Insurance Notice”) and the Seller may, by providing written notice to the Buyer or the Buyer’s agent within [2] Business Days after the Insurance Notice is provided, elect to accelerate the Completion Date to a date that is [5] Business Days after the Insurance Notice is provided, and the Adjustment Date and the Possession Date will be adjusted so that they will occur with the same relativity to the new extended Completion Date as they had to the original Completion Date.<br/><br/>
     
     The parties agree that time will remain of the essence.`,
  },
  {
    type: "clause",
    category: [`condo`],
    isCommon: "no",
    title: `Seller to Credit if Special Levy`,
    notes: `This clause ensures the Seller, not the Buyer, is responsible for paying 
    any special levy approved before the sale completes. It protects the Buyer by 
    requiring the Seller's portion of the levy to be deducted from the sale proceeds and 
    paid directly to the strata corporation.<br/>`,
    text: `If a special levy is approved by the members of the Strata Corporation before the completion date, the Seller(s) shall credit the Buyer with 100% of the portion of the special levy that the Buyer(s) is obligated to pay under the Strata Property Act and the Seller hereby directs the Buyer's lawyer or notary public to hold back such credit from the sale proceeds and to remit it to the strata corporation.`,
  },
  {
    type: "clause",
    category: [`condo`],
    isCommon: "no",
    title: `Seller to Notify if Bylaws/Rules are Amended`,
    notes: `This clause requires the Seller to inform the Buyer of any new or proposed 
    changes to the strata bylaws or rules before completion. It protects the Buyer by 
    ensuring they are aware of any amendments that could affect the property's use, 
    value, or ownership obligations.<br/>`,
    text: `The Seller(s) will notify the Buyer before the completion date of any notice of a resolution to amend the bylaws or rules of the strata corporation, or the bylaws or rules of a section to which the strata lot belongs, or any amendment to such bylaws or rules, that the Seller has not previously disclosed to the Buyer. The Seller will promptly deliver a copy of the relevant resolution or notice of resolution to the Buyer.`,
  },
  {
    type: "clause",
    category: [`condo`],
    isCommon: "no",
    title: `Seller Warrants - Strata Fees, Parking, Locker...etc.`,
    notes: `This clause confirms key strata details, including the current monthly 
    fees, assigned parking, storage, and mailbox numbers, as well as property management 
    contact information. It protects the Buyer by ensuring accurate disclosure of the 
    unit's associated costs and designations.<br/>`,
    text: `The Seller warrants the current monthly strata fees is $____________ and the following parking stall(s), storage locker(s) and mailbox # are designated to the unit:<br/>
Parking# ____________________________________<br/>
Locker# __________________________________<br/>
Mail Box# _________________________________<br/>
Property Management company name: ___________________________<br/>
Contact phone number:________________________.
`,
  },
  {
    type: "clause",
    category: [`condo`],
    isCommon: "no",
    title: `No Growth or Manufacture of Illegal Substances`,
    notes: `This clause protects the Buyer by ensuring the property has not been used 
    to grow marijuana or manufacture illegal drugs, either during the Seller's ownership 
    or to the Seller's knowledge before that. The warranty continues after the sale is 
    complete, providing ongoing assurance about the property's condition and history.<br/>`,
    text: `Seller(s) represents and warrants that, during the time the Seller has owned the strata lot, neither the strata lot nor any limited common property associated with the strata lot has been used for the growth of marijuana or manufacture of any illegal substances. This warranty shall survive and not merge on the completion of this transaction. Further, the Seller represents that, to the best of the Seller's knowledge and belief, neither the strata lot nor any limited common property associated with the strata lot has ever been used for the growth of marijuana or manufacture of illegal substances.`,
  },
  {
    type: "clause",
    category: [`residential`, `fsbo`, `mere`],
    isCommon: "no",
    title: `No Growth or Manufacture of Illegal Substances`,
    notes: `This clause protects the Buyer by confirming that, while under the Seller's 
    ownership, the property was never used for illegal drug production or unauthorized 
    cannabis growth. It assures the Buyer that the property's use has complied with the 
    law and hasn't been exposed to related damage or risks.<br/>`,
    text: `The Seller represents and warrants that, during the time the Seller has owned the Property, the Property has not been used to grow cannabis (other than as permitted by law) or for the growth or manufacture of illegal substances.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "no",
    title: `Chattels and Fixtures - Good Working Order`,
    notes: `This clause ensures the Seller guarantees that any movable items (chattels) 
    and permanent fixtures (like appliances) listed in the agreement will be in good 
    working order and free of liens/encumbrances at the time of completion. It protects 
    the Buyer by confirming the property will be ready for use as intended.<br/>`,
    text: `The Seller represents and warrants that the chattels and fixtures as included in this Contract of Purchase and Sale will be in good working order and free from all liens and encumbrances on the completion date. The Parties agree that this representation and warranty shall survive and not merge on completion of this transaction, but apply only to the state of the property at completion of this transaction.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "no",
    title: `Appliances same as viewing date`,
    notes: `This clause protects the Buyer by confirming that the appliances included 
    in the purchase price will be the same as those viewed by the Buyer on the viewing 
    date. It ensures the Buyer isn't paying for items that don't match what they saw.<br/>`,
    text: `Seller warrants the appliances included in the purchase price will be the same as those viewed by the Buyer on ___________.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "no",
    title: `Electrical, Plumbing, Gas, Appliances - Good Working Order`,
    notes: `This clause ensures the Seller is responsible for delivering the property 
    with all electrical, plumbing, gas, and appliances in good working condition at the 
    Possession Date. It protects the Buyer by confirming the property will be ready for 
    use as intended.<br/>`,
    text: `Seller is responsible to deliver the property with all electrical, plumbing, gas and appliances in good working condition at the Possession Date.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "no",
    title: `Possession - Clear of Personal Belongings`,
    notes: `This clause protects the Buyer by ensuring the property is cleared of any 
    personal belongings, debris, and garbage on the day of possession. It ensures the 
    property is ready for the Buyer to move in.<br/>`,
    text: `The Seller warrants that the property will be left free and clear of any of the Seller's personal belongings, debris and garbage on the day of the possession.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "no",
    title: `Outstanding Notices, Work Orders, Bylaw Infractions or Liens`,
    notes: `This clause ensures the Seller warrants that there are no outstanding notices, 
    work orders, bylaw infractions, or liens against the property. It protects the Buyer 
    by confirming the property is free of any outstanding claims or obligations that could 
    affect its use or value.<br/>`,
    text: `Seller warrants that there are no notices or requests outstanding against the property from any governmental/city/district/municipal authority or official, insurance company, or board of fire underwriters requesting performance of any work or alteration in respect of the property and that there are no outstanding work orders, bylaw infractions or liens against the property.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "no",
    title: `Confirmation of Tenancy Details`,
    notes: `This clause should be used for just residential. This clause, once 
    completed, will contain Tenant's personal information, as defined in the Personal 
    Information Protection Act. Before disclosing the information set out in this 
    clause to the Buyer, the Seller or the Seller's licensee should obtain the 
    Tenant's consent to that disclosure. If consent cannot be obtained, the Seller 
    and/or the Seller's licensee should obtain legal advice relating to their 
    obligations under privacy law.

`,
    text: `The Seller represents and warrants:<br/>
 (a) the Property is subject to a tenancy agreement under the Residential Tenancy Act;<br/>
 (b) the monthly rent is (amount);<br/>
 (c) the monthly rent includes (any inclusions);<br/>
 (d) the monthly rent is due on the (number) day of each month;<br/>
 (e) the last rental increase was (date);<br/>
 (f) a security deposit of (amount) was paid by the Tenant on (date); and<br/>
 (g) a pet damage deposit of (amount) was paid by the Tenant on (date).<br/>
(h) a copy of move in inspection report & tenancy agreement will be delivered to Buyer upon completion.<br/><br/>
All deposits + interest will be credited to the Buyer on the statement of adjustments.
`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "no",
    title: `Notice to End Tenancy`,
    notes: `This clause ensures the Seller promptly gives notice to end the tenancy 
    in accordance with the provisions of the Residential Tenancy Act to any Tenants of 
    the Property. It protects the Buyer by ensuring they are aware of any changes that 
    could affect the property's use or value.<br/>`,
    text: `If the Seller has received from the Buyer a request to give a notice to end tenancy in accordance with section 49 of the Residential Tenancy Act, the Seller will promptly give a notice to end the tenancy in accordance with the provisions of the Residential Tenancy Act to any Tenants of the Property.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`],
    isCommon: "no",
    title: `Seller Indemnification - Tax Liability`,
    notes: `This clause ensures the Seller indemnifies the Buyer from all losses and 
    liabilities whatsoever arising out of or relating to tax that may be assessed under 
    the Income Tax Act which relate to the Seller's time of ownership of the property. 
    It protects the Buyer by ensuring they are not responsible for any tax that may be 
    assessed under the Income Tax Act.<br/>`,
    text: `The Seller shall further indemnify the Buyer from all losses and liabilities whatsoever arising out of or relating to tax that may be assessed under the Income Tax Act which relate to the Seller’s time of ownership of the property.`,
  },
  {
    type: "clause",
    category: [`residential`, `condo`, `fsbo`, `mere`, `assign`, `assignmere`],
    isCommon: "no",
    title: `Probate Clause (probate not completed)`,
    notes: `This clause is required when the Seller is selling a property that is under 
    probate. It protects the Buyer by ensuring the Seller has the authority to sell the 
    property and that the property is free of any claims or obligations that could 
    affect its use or value.<br/>`,
    text: `Subject to the Seller receiving the following by _______________:(1) a copy of a grant of probate or letters of administration which allow the Property to be sold; and(2) assurance that everyone entitled to claim under the Wills, Estates and Succession Act has waived or released their claims against the Property. This condition is for the sole benefit of the Seller.`,
  },
  {
    type: "clause",
    category: [],
    isCommon: "no",
    title: `Deposit Payable within Specified Period`,
    notes: `This clause ensures the Buyer pays the deposit within a specified period after 
    accepting the offer. It protects the Seller by confirming the deposit is received 
    on time and helps prevent delays in the sale process.<br/>`,
    text: `The Deposit is payable within (number of hours) hours of acceptance of this offer.`,
  },
  {
    type: "clause",
    category: [],
    isCommon: "no",
    title: `Seller Onsite Sewerage System Representation and Warranty`,
    notes: `This clause ensures the Seller represents and warrants that the onsite 
    sewerage system (System) on the Property was installed, inspected and approved by 
    an authorized person (as defined in the Sewerage System Regulation) and a permit 
    or letter of certification respecting the System is on file with the relevant health 
    authority. It protects the Buyer by confirming the system is compliant with regulations 
    and meets safety standards.<br/>`,
    text: `The Seller represents and warrants to the Buyer that the onsite sewerage system (“System”) on the Property was installed, inspected and approved by an authorized person (as defined in the Sewerage System Regulation) and a permit or letter of certification respecting the System is on file with the relevant health authority.`,
  },
  {
    type: "clause",
    category: [],
    isCommon: "no",
    title: `Inspection - Deficiency List`,
    notes: ``,
    text: `The Seller, at the Seller’s Expense, will complete and/or repair the items specified below or on the attached deficiency list and valued at $___________________________. The list forms a part of this contract. The quality of work and materials used will be equal to or better than that of the surrounding construction.<br/>
    The Buyer will hold back from the sale proceeds the amount specified above until all the deficiencies specified in the deficiency list are completed, and will place this hold-back in the conveyancer’s trust account. In the event that all the deficiencies are not corrected within 15 days of completion, the Seller authorizes the Buyer’s conveyancer to release the balance of the holdback to the Buyer.<br/>
    Seller agrees to repair/replace the deficiencies at least ____ days before completion and will allow the Buyer access to the property at least _____ days before completion to ensure the deficiencies have been corrected.<br/>
    Any dispute concerning completion of deficiencies and release of the hold-back will be settled by arbitration under the Commercial Arbitration Act of B.C.<br/>
    All other terms and conditions in the said Contract of Purchase and Sale remain the same and in full force and effect.<br/>
    1)<br/>
    2)<br/>
    3)<br/>
    4)
    `,
  },
  {
    type: "clause",
    category: [],
    isCommon: "no",
    title: `Inspection - Seller gives Buyer Credit on Statement of Adjustments`,
    notes: `notes<br/>
    `,
    text: `Seller agrees to give the Buyer a credit on the statement of adjustments of $ ________________ for the following items found during the inspection: _________________________.<br/>
    ALL OTHER TERMS AND CONDITIONS IN THE SAID AGREEMENT REMAIN THE SAME AND IN FULL FORCE AND EFFECT.
    `,
  },
  {
    type: "clause",
    category: [],
    isCommon: "no",
    title: `Inspection - Seller Reduces Price Due to Defect(s)`,
    notes: `notes<br/>
    `,
    text: `Buyer and Seller agree to reduce the purchase price to ____________________________ for the following items found during the inspection: ___________________________________<br/>
    ALL OTHER TERMS AND CONDITIONS IN THE SAID AGREEMENT REMAIN THE SAME AND IN FULL FORCE AND EFFECT.
    `,
  },
  {
    type: "clause",
    category: [],
    isCommon: "yes",
    title: `Buyer Sewerage System Inspection`,
    notes: `notes<br/>
    `,
    text: `Subject to the Buyer, at the Buyer's expense, obtaining and being satisfied, on or before _____________, with a report from an authorized person (as defined in the Sewerage System Regulation (“Regulation’))respecting the operational function and condition of the components of the onsite sewerage system (“System”) on the Property and compliance of the System with the Regulation. This condition is for the sole benefit of the Buyer.`,
  },
  {
    type: "clause",
    category: [],
    isCommon: "yes",
    title: `Water Potability`,
    notes: `notes<br/>
    `,
    text: `Subject to the Buyer, at the Buyer's expense, receiving a water potability test report from a qualified professional for water used or consumed on the Property and being satisfied, on or before _____________, with the results of that report. This condition is for the sole benefit of the Buyer.`,
  },
  {
    type: "clause",
    category: [],
    isCommon: "yes",
    title: `Water Quality and Supply`,
    notes: `notes<br/>
    `,
    text: `Subject to the Buyer, at the Buyer’s expense, receiving a report from a qualified professional concerning the quantity and quality of the Property’s water supply and being satisfied, on or before _____________, with the results of that report. This condition is for the sole benefit of the Buyer.`,
  },
  {
    type: "clause",
    category: [`lease`, `landlordSRP`, `leaseMere`],
    isCommon: "no",
    title: `What You Are Allowed to Do`,
    notes: `This is a general list of activities that you are allowed to do as a
    REALTOR® while carrying out Rental Placement Services. Keep in mind, some only 
    apply based on whether your client is the Landlord or the Tenant.
    <br/>
    `,
    text: `<ol>
    <li>Advertise the rental property</li>
    <li>Show the rental property</li>
    <li>Receive Tenant Applications and shortlist applicants</li>
    <li>Prepare the Lease or Tenancy Agreement on behalf of the owner</li>
    <li>Negotiate the rent and the terms of the Lease or Tenancy Agreement </li>
    <li>Collect the Tenants signature on the Lease or Tenancy Agreement</li>
    <li>Collect security deposit - directly to the Landlord only</li>
    </ol>`,
  },
  {
    type: "clause",
    category: [`lease`, `landlordSRP`, `leaseMere`],
    isCommon: "no",
    title: `What You Are Not Allowed to Do`,
    notes: `This is a general list of activities that you are allowed to do as a
    REALTOR® while carrying out Rental Placement Services. Keep in mind, some only 
    apply based on whether your client is the Landlord or the Tenant.
    <br/>
    `,
    text: `<ol>
    <li>Conduct move-in inspection report</li>
    <li>Sign the Tenancy Agreement</li>
    <li>Collect rent from Tenants</li>
    <li>Make payments on behalf of the property owner to 3rd parties</li>
    <li>Negotiate or enter into a contract on behalf of the owner</li>
    <li>Supervise employees or contractors hired by the owner</li>
    <li>Manage Landlord and Tenant matters</li>
    </ol>`,
  },
];

export default clauseData;

/*
{
    type: "clause",
    category: [``],
    isCommon: "no",
    title: `title`,
    notes: `notes<br/>
    `,
    text: ``,
  },





*/
